import { Outlet, useOutletContext } from "react-router-dom";

export function OutletContextPassthroughGuard() {
  const outletContext = useOutletContext();
  return <Outlet context={outletContext} />;
}
